export const SAVED_FILTERS_API_BASE_URL = '/api/data-alert/criteria';
export const MAX_SAVED_FILTERS_COUNT = 200;
